import React from 'react'
import { TextField } from 'hhsoig-design-system-core'

export class DependentField extends React.Component {
  componentDidMount() {
    const { values, dependency, fieldName, setFieldValue } = this.props
    if (!values[fieldName]) {
      setFieldValue(fieldName, values[dependency] || '')
    }
  }

  render() {
    const {
      errors,
      touched,
      label,
      labelClassName,
      fieldName,
      hint,
      handleChange,
      autoFocus,
      values
    } = this.props
    const errorMessage =
      touched && touched[fieldName] && errors && errors[fieldName]
    return (
      <TextField
        label={label}
        labelClassName={labelClassName}
        name={fieldName}
        hint={hint}
        value={values[fieldName] || ''}
        onChange={handleChange}
        autoFocus={autoFocus}
        errorMessage={errorMessage}
      />
    )
  }
}
